import { Form, Button, FormItem, Input, Card, Table, TableColumn, Pagination, Message, MessageBox } from 'element-ui'
import Vue from 'vue'
Vue.use(Form)
Vue.use(Button)
Vue.use(Card)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
// 使用原型扩展Vue
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$message = Message
